import React, { useState } from "react";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";

// import JS files

// import Others files
const RingSizeItem = (props) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <div className="flex justify-between mt-3 items-center">
        <div className=" basis-1/2 text-center">
          <span className="text-base text-gray-700">{props.label}</span>
        </div>
        <div className="basis-1/2  text-center">
          <MuiTextFieldHook
            id={`outlined-basic-${props.label}`}
            label="وزن"
            variant="outlined"
            size="small"
            name={`weight${props.label}`}
            control={props.control}
            register={props.register}
            isLTR={true}
            type="number"
          />
        </div>
      </div>
    </>
  );
};

export default RingSizeItem;
